<template>
    <!--Login Layout -->
    <div id="app" v-if="$route.path === '/login'" class="bgImg">
        <router-view/>
        <vue-snotify></vue-snotify>
        <vue-progress-bar></vue-progress-bar>
    </div>
    <!-- Dashboard  Layout -->
    <div id="app" v-else class="container-fluid no-gutters">
        <router-view/>
        <vue-snotify></vue-snotify>
        <vue-progress-bar></vue-progress-bar>
    </div>
</template>

<script>
import NavBar from './views/includes/NavBar';

export default {
  components: { NavBar },
  created() {
    // Get Locale From Store if present and set it.
    const locale = this.$store.getters.getLocale;
    if (locale !== null) {
    	if (this.$i18n.locale !== locale) { this.$i18n.locale = locale; }
    }
  },
};
</script>
